import Vue from 'vue';
import uuid from 'uuid/v4';
import axios from 'axios';
import _ from 'lodash';
import funPdf from '../../utils/funPdf/funPdf';

const { downloadPDF } = funPdf;
const SERVICE_CREATE_URL = '/inventarios/crear';
const SEND_EMAIL_STATUS_USER = '/inventarios/sendEmailStatus';
const SERVICE_GET_INVENTORY_URL = '/inventarios/by_contract/';
const SERVICE_UPDATE_DATE_APPROVAL = '/inventarios/updateDateSendApproval/';
const SERVICE_UPDATE_INVENTORY_APPROVED = '/inventarios/updateDateInventoryApproved/';
const SERVICE_UPDATE_RISK_STATUS_URL = '/inventarios/status_update';
const SERVICE_DELETE_RISK_REVIEWED_URL = '/inventarios/delete-risk';
const SERVICE_UPDATE_RISK_REVIEWED_URL = '/inventarios/edit-risk';
const SERVICE_CREATE_UPDATE_DRAFT_URL = '/inventarios/draft/create_or_update';

const SERVICE_GET_PDF_REVIEW_URL = '/inventarios/print_review';
const SERVICE_GET_PDF_URL = '/inventarios/print';
const SERVICE_GET_PDF_TAREA_URL = '/inventarios/print_tarea';
const SERVICE_GET_PDF_MEDIOAMBIENTAL_URL = '/inventarios/print_medioambiental';

const GET_PDF_RIESGO_BOWTIE_INV_URL = '/inventarios/riesgos/print_bowtie_inv';
const GET_PDF_RIESGO_BOWTIE_URL = '/inventarios/riesgos/print_bowtie';
const GET_PDF_RIESGO_TABLA_INV_URL = '/inventarios/riesgos/print_tabla_inv';
const GET_INVENTORY_RISK_IMPACT_STATUS = '/inventarios/inventory_risk_impact_status';

const CHANGE_STATUS_INVENTORY = '/inventarios/changeStatusInventory';

const SET_INVENTORY = 'SET_INVENTORY';
const SET_INVENTORY_COPY = 'SET_INVENTORY_COPY';
const ADD_TASK = 'ADD_TASK';
const DELETE_TASK = 'DELETE_TASK';
const SELECT_TASK = 'SELECT_TASK';
const EDIT_TASK = 'EDIT_TASK';

const ADD_RISK = 'ADD_RISK';
const ADD_RISK_ANUAL = 'ADD_RISK_ANUAL';
const DELETE_RISK = 'DELETE_RISK';
const ADD_CUSTOM_RISK = 'ADD_CUSTOM_RISK';
const EDIT_CUSTOM_RISK = 'EDIT_CUSTOM_RISK';

const ADD_CAUSE = 'ADD_CAUSE';
const DELETE_CAUSE = 'DELETE_CAUSE';
const EDIT_CAUSE = 'EDIT_CAUSE';
const ADD_IMPACT = 'ADD_IMPACT';
const DELETE_IMPACT = 'DELETE_IMPACT';
const EDIT_IMPACT = 'EDIT_IMPACT';
const ADD_PREVENTIVE_CONTROL = 'ADD_PREVENTIVE_CONTROL';
const DELETE_PREVENTIVE_CONTROL = 'DELETE_PREVENTIVE_CONTROL';
const EDIT_PREVENTIVE_CONTROL = 'EDIT_PREVENTIVE_CONTROL';
const ADD_MITIGATION_CONTROL = 'ADD_MITIGATION_CONTROL';
const DELETE_MITIGATION_CONTROL = 'DELETE_MITIGATION_CONTROL';
const EDIT_MITIGATION_CONTROL = 'EDIT_MITIGATION_CONTROL';
const ADD_EVALUATOR = 'ADD_EVALUATOR';
const DELETE_EVALUATOR = 'DELETE_EVALUATOR';
const EDIT_EVALUATOR = 'EDIT_EVALUATOR';
const ADD_PDF = 'ADD_PDF';
const ADD_PARTICIPANTE = 'ADD_PARTICIPANTE';
const EDIT_PARTICIPANTE = 'EDIT_PARTICIPANTE';
const DELETE_PARTICIPANTE = 'DELETE_PARTICIPANTE';

const RESET_STATUS_RISK = 'RESET_STATUS';
const SET_INVENTORY_STATUS = 'SET_INVENTORY_STATUS';

const ASSIGN_RISK = 'ASSIGN_RISK';
const EDIT_RISK = 'EDIT_RISK';
const EDIT_INVENTORY = 'EDIT_INVENTORY';
const SET_STATUS_CAMBIO = 'SET_STATUS_CAMBIO';
const CHANGE_STATUS_CAMBIO = 'CHANGE_STATUS_CAMBIO';
const DELETE_CAMBIO = 'DELETE_CAMBIO';
const RESET_CAMBIOS = 'RESET_CAMBIOS';
const EDIT_CUSTOM_RISK_YEAR = 'EDIT_CUSTOM_RISK_YEAR';
const UP_RISK = 'UP_RISK';
const DOWN_RISK = 'DOWN_RISK';
const UP_TASK = 'UP_TASK';
const DOWN_TASK = 'DOWN_TASK';
const REPLACE_RISKS = 'REPLACE_RISKS';

const borra = {
  me: null,
};

function putoIEAssign(o, k, v) {
  borra.me = o[k];
  o[k] = v;
  delete borra.me;
}


const state = {
  cambios: [],
  draftID: null,
  inventario: {},
  inventario_copy: {},
  selectedIndexTask: null,
};

const getters = {
  cambios: state => state.cambios,
  inventario: state => state.inventario,
  inventario_copy: state => state.inventario_copy,
  tareas: state => state.tareas,
  selectedIndexTask: state => state.selectedIndexTask,
};

const actions = {
  downTask({
    commit,
  }, index) {
    return new Promise((resolve) => {
      commit(DOWN_TASK, index);
    });
  },
  upTask({
    commit,
  }, index) {
    return new Promise((resolve) => {
      commit(UP_TASK, index);
    });
  },
  downRisk({
    commit,
  }, index) {
    return new Promise((resolve) => {
      commit(DOWN_RISK, index);
    });
  },
  upRisk({
    commit,
  }, index) {
    return new Promise((resolve) => {
      commit(UP_RISK, index);
    });
  },
  setChange({
    commit,
  }, cambios) {
    return new Promise((resolve) => {
      commit(CHANGE_STATUS_CAMBIO, cambios);
    });
  },
  addChange({
    commit,
  }, cambio) {
    return new Promise((resolve) => {
      commit(SET_STATUS_CAMBIO, cambio);
    });
  },
  resetChanges({
    commit,
  }) {
    return new Promise((resolve) => {
      commit(RESET_CAMBIOS);
    });
  },
  deleteCambio({
    commit,
  }, index) {
    return new Promise((resolve) => {
      commit(DELETE_CAMBIO, index);
    });
  },
  resetInventory({
    commit,
  }) {
    localStorage.removeItem('inventory');
    commit(SET_INVENTORY, {});
  },
  InventoryEditRisk({
    commit,
    state,
  }, {
    risk,
    obj,
  }) {
    commit(ASSIGN_RISK, {
      risk,
      obj,
    });
  },
  getInventariosDonde({
    commit,
  }, {
    inventory_ids,
    role,
    superAdmin,
    user_id,
    faena_id,
  }) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      // si traer usuario y faena filtrara por eso y no una lista de inventarios/contratos
      let sendObj = {};
      if (user_id && faena_id) {
        inventory_ids = [];
        sendObj = {
          inventory_ids,
          role,
          superAdmin,
          user_id,
          faena_id,
        };
      } else {
        sendObj = {
          inventory_ids,
          role,
          superAdmin,
        };
      }
      axios.post(GET_INVENTORY_RISK_IMPACT_STATUS, sendObj, config)
        .then(response => resolve(response))
        .catch((error) => {
          if (error) {
            resolve({
              message: 'Lo sentimos, no ha se podido establecer una conexión con el servidor. Intente nuevamente.',
            });
          }
        });
    });
  },
  setInventario({
    commit,
  }, inventario) {
    return new Promise((resolve) => {
      state.draftID = inventario._id;
      commit(SET_INVENTORY, inventario);
      resolve();
    });
  },
  setInventarioCopy({
    commit,
  }, inventario) {
    return new Promise((resolve) => {
      commit(SET_INVENTORY_COPY, inventario);
      resolve();
    });
  },
  setInventoryStatus({
    commit,
  }, status) {
    return new Promise((resolve) => {
      commit(SET_INVENTORY_STATUS, status);
      resolve();
    });
  },
  createOrUpdateDraft({
    state,
  }) {
    const {
      inventario,
    } = state;
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };

      inventario.draft = true;
      inventario.usuario_creador_id = inventario.usuario_creador_id || JSON.parse(localStorage
        .getItem('user')).id;
      inventario.contrato_id = inventario.contrato_id || JSON.parse(localStorage.getItem(
        'actualContract',
      ))._id;
      if (inventario.empresa_id) {
        inventario.empresa_id = inventario.empresa_id || JSON.parse(localStorage.getItem(
          'actualContract',
        )).empresa_id;
      }

      // Sin tareas, no se guarda borrador. Success true porque no importa que no se guarde
      /* if (inventario && inventario.tareas && inventario.tareas.length === 0) {
        resolve({
          success: true,
        });
        return;
      } */

      // Borra siempre el ID del inventario
      const pInventario = _.omit(state.inventario, ['_id']);

      axios.post(`${SERVICE_CREATE_UPDATE_DRAFT_URL}/${state.draftID}`, pInventario, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              message: response.data.message,
            });
          } else if (!response.data.updated) {
            if (state.inventario._id == undefined) {
              // si es indefinido es pq se creo en el frontend
              // y por ende no tenia id, ahora lo recibe
              state.inventario._id = response.data.id;
            }
            state.draftID = response.data.id;
            resolve({
              success: true,
            });
          } else {
            resolve({
              success: true,
            });
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              message: 'Lo sentimos, no ha se podido establecer una conexión con el servidor. Intente nuevamente.',
            });
          }
        });
    });
  },
  saveInventario({
    commit,
    state,
  }) {
    const {
      inventario,
    } = state;
    const pInventario = _.omit(state.inventario, ['_id']);

    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };

      axios.post(`${SERVICE_CREATE_URL}/${inventario._id}`, pInventario, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            resolve({
              status: true,
            });
            commit(SET_INVENTORY, inventario);
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  setDateSendApproval({
    commit,
  }, inventory) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(SERVICE_UPDATE_DATE_APPROVAL + inventory._id, config)
        .then((response) => {
          if (response.data.status === true) {
            resolve({
              status: true,
            });
          } else {
            resolve({
              status: false,
            });
          }
        })
        .catch((error) => {
          resolve({
            status: false,
            error: 'Lo sentimos, surgió un error. Intente nuevamente.',
          });
        });
    });
  },
  setDateInventoryApproved({
    commit,
  }, inventory) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(SERVICE_UPDATE_INVENTORY_APPROVED + inventory._id, config)
        .then((response) => {
          if (response.data.status === true) {
            resolve({
              status: true,
            });
          } else {
            resolve({
              status: false,
            });
          }
        })
        .catch((error) => {
          resolve({
            status: false,
            error: 'Lo sentimos, surgió un error. Intente nuevamente.',
          });
        });
    });
  },
  changeStatusInventory({
    commit,
  }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(CHANGE_STATUS_INVENTORY, params, config)
        .then((response) => {
          if (response.data.status === true) {
            resolve({
              status: true,
            });
          } else {
            resolve({
              status: false,
            });
          }
        })
        .catch((error) => {
          resolve({
            status: false,
            error: 'Lo sentimos, surgió un error. Intente nuevamente.',
          });
        });
    });
  },
  sendEmailUser({
    commit,
  }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(SEND_EMAIL_STATUS_USER, params, config)
        .then((response) => {
          if (response.data.status === true) {
            resolve({
              status: true,
            });
          } else {
            resolve({
              status: false,
            });
          }
        })
        .catch((error) => {
          resolve({
            status: false,
            error: 'Lo sentimos, surgió un error. Intente nuevamente.',
          });
        });
    });
  },
  getInventory({
    commit,
  }, contract) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(SERVICE_GET_INVENTORY_URL + contract._id, config)
        .then((response) => {
          state.draftID = response.data._id;
          commit(SET_INVENTORY, response.data);
          resolve({
            status: true,
            inventory: response.data,
          });
        })
        .catch((error) => {
          state.draftID = null;
          localStorage.removeItem('inventory');
          commit(SET_INVENTORY, {});
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  addTask({
    commit,
  }, task) {
    // retorno la tarea creada
    if (task.anual && task.anual === true) {
      commit(ADD_TASK, task);
      return state.inventario_copy.tareas[state.inventario_copy.tareas.length - 1];
    } else {
      commit(ADD_TASK, task);
      return state.inventario.tareas[state.inventario.tareas.length - 1];
    }
  },
  addParticipante({
    commit,
  }, participante) {
    commit(ADD_PARTICIPANTE, participante);
  },
  editParticipante({
    commit,
  }, participante) {
    commit(EDIT_PARTICIPANTE, participante);
  },
  replaceRisks({
    commit,
  }, data) {
    commit(REPLACE_RISKS, data);
  },
  deleteParticipante({
    commit,
  }, participante) {
    commit(DELETE_PARTICIPANTE, participante);
  },
  editTask({
    commit,
  }, params) {
    commit(EDIT_TASK, {
      anual: params.anual === true ? true : false,
      taskId: params.taskId,
      nombre: params.nombre,
      subtitulo: params.subtitulo,
    });
  },
  deleteTask({
    commit,
  }, task) {
    return new Promise((resolve) => {
      commit(DELETE_TASK, task);
      resolve();
    });
  },
  selectTask({
    commit,
    state,
  }, task) {
    if (task.anual && task.anual === true && ["2", 2].includes(state.inventario.status)) {
      return new Promise((resolve) => {
        const tasks = state.inventario_copy.tareas;
        const indexTask = tasks.findIndex(tarea => (tarea.id || tarea._id) === (task.id || task
          ._id));
        commit(SELECT_TASK, indexTask);
        resolve();
      });
    } else {
      return new Promise((resolve) => {
        const tasks = state.inventario.tareas;
        const indexTask = tasks.findIndex(tarea => (tarea.id || tarea._id) === (task.id || task
          ._id));
        commit(SELECT_TASK, indexTask);
        resolve();
      });
    }
  },
  addRisk({
    commit,
    state,
  }, risk) {
    if (risk.anual && risk.anual === true) {
      const risks = state.inventario_copy.tareas[state.selectedIndexTask].riesgos;
      if (risks) {
        const indexRisk = risks.findIndex(riesgo => riesgo._id === risk._id);
        if (indexRisk >= 0) {
          commit(DELETE_RISK, {
            indexRisk,
            indexTask: state.selectedIndexTask,
          });
          return;
        }
      }
      commit(ADD_RISK, {
        anual: true,
        risk,
        indexTask: state.selectedIndexTask,
      });
    } else {
      const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
      if (risks) {
        const indexRisk = risks.findIndex(riesgo => riesgo._id === risk._id);
        if (indexRisk >= 0) {
          commit(DELETE_RISK, {
            anual: true,
            indexRisk,
            indexTask: state.selectedIndexTask,
          });
          return;
        }
      }
      commit(ADD_RISK, {
        anual: false,
        risk,
        indexTask: state.selectedIndexTask,
      });
    }
  },
  duplicateRisk({
    commit,
    state,
  }, duplicate) {
    commit(ADD_RISK, {
      risk: duplicate.risk,
      indexTask: duplicate.index,
    });
  },
  duplicateRiskAnual({
    commit,
    state,
  }, duplicate) {
    commit(ADD_RISK_ANUAL, {
      risk: duplicate.risk,
      indexTask: duplicate.index,
    });
  },
  addCustomRisk({
    commit,
  }, params) {
    commit(ADD_CUSTOM_RISK, {
      nombre: params.nombre,
      medioambiental: params.medioambiental,
      indexTask: state.selectedIndexTask,
    });
  },
  editCustomRisk({
    commit,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const indexRisk = risks.findIndex(risk => risk._id === params._id);
    if (indexRisk >= 0) {
      commit(EDIT_CUSTOM_RISK, {
        indexTask: state.selectedIndexTask,
        indexRisk,
        risk: params,
      });
    }
  },
  editCustomRiskYear({
    commit,
  }, params) {
    const risks = state.inventario_copy.tareas[state.selectedIndexTask].riesgos;
    const indexRisk = risks.findIndex(risk => risk._id === params._id);
    if (indexRisk >= 0) {
      commit(EDIT_CUSTOM_RISK_YEAR, {
        indexTask: state.selectedIndexTask,
        indexRisk,
        risk: params,
      });
    }
  },
  deleteCustomRisk({
    commit,
  }, risk) {
    if (risk.anual && risk.anual === true && [2, "2"].includes(state.inventario.status)) {
      const risks = state.inventario_copy.tareas[state.selectedIndexTask].riesgos;
      const indexRisk = risks.findIndex(r => r._id === risk._id);
      if (indexRisk >= 0) {
        commit(DELETE_RISK, {
          anual: true,
          indexTask: state.selectedIndexTask,
          indexRisk,
        });
      }
    } else {
      const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
      const indexRisk = risks.findIndex(r => r._id === risk._id);
      if (indexRisk >= 0) {
        commit(DELETE_RISK, {
          anual: false,
          indexTask: state.selectedIndexTask,
          indexRisk,
        });
      }
    }
  },
  addCause({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      commit(RESET_STATUS_RISK, riskIndex);
      commit(ADD_CAUSE, {
        index: riskIndex,
        causa: params.causa,
      });
    }
  },
  addImpact({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      commit(RESET_STATUS_RISK, riskIndex);
      commit(ADD_IMPACT, {
        index: riskIndex,
        impacto: params.impacto,
      });
    }
  },
  addPreventiveControl({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const preventiveControlId = uuid();
      params.causesId.forEach((causeId) => {
        const causeIndex = risk.causas.findIndex(cause => cause.id === causeId);
        if (causeIndex >= 0) {
          commit(RESET_STATUS_RISK, riskIndex);
          commit(ADD_PREVENTIVE_CONTROL, {
            riskIndex,
            causeIndex,
            controlPreventivo: params.controlPreventivo,
            controlPreventivoId: preventiveControlId,
          });
        }
      });
    }
  },
  addMitigationControl({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const mitigationControlId = uuid();
      const impactIndex = risk.impactos.findIndex(impact => impact.id === params.impactId);
      if (impactIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(ADD_MITIGATION_CONTROL, {
          riskIndex,
          impactIndex,
          controlMitigador: params.controlMitigador,
          controlMitigadorId: mitigationControlId,
        });
      }
    }
  },
  deleteCause({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const causeIndex = risk.causas.findIndex(cause => cause.id === params.causeId);
      if (causeIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(DELETE_CAUSE, {
          riskIndex,
          causeIndex,
        });
      }
    }
  },
  editCause({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const causeIndex = risk.causas.findIndex(cause => cause.id === params.causeId);
      if (causeIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(EDIT_CAUSE, {
          riskIndex,
          causeIndex,
          cause: params.cause,
        });
      }
    }
  },
  deleteImpact({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const impactIndex = risk.impactos.findIndex(impact => impact.id === params.impactId);
      if (impactIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(DELETE_IMPACT, {
          riskIndex,
          impactIndex,
        });
      }
    }
  },
  editImpact({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const impactIndex = risk.impactos.findIndex(impact => impact.id === params.impactId);
      if (impactIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(EDIT_IMPACT, {
          riskIndex,
          impactIndex,
          impact: params.impact,
        });
      }
    }
  },
  deletePreventiveControl({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      risk.causas.forEach((cause, causeIndex) => {
        const controlIndex = cause.controles_preventivos.findIndex(control => control.id
          === params.controlId);
        if (controlIndex >= 0) {
          commit(RESET_STATUS_RISK, riskIndex);
          commit(DELETE_PREVENTIVE_CONTROL, {
            riskIndex,
            causeIndex,
            controlIndex,
          });
        }
      });
    }
  },
  editPreventiveControl({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      commit(RESET_STATUS_RISK, riskIndex);
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      risk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(control => control.id
            === params.controlId);
        }

        // El control editado, tiene asociada esta causa?
        if (params.control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            commit(EDIT_PREVENTIVE_CONTROL, {
              riskIndex,
              causeIndex,
              controlIndex,
              controlPreventivo: params.control.nombre,
              critico: params.control.critico,

            });
          } else {
            // Agregar control a causa
            commit(ADD_PREVENTIVE_CONTROL, {
              riskIndex,
              causeIndex,
              controlPreventivo: params.control.nombre,
              controlPreventivoId: params.controlId,
              critico: params.control.critico,
            });
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            commit(DELETE_PREVENTIVE_CONTROL, {
              riskIndex,
              causeIndex,
              controlIndex,
            });
          }
        }
      });
    }
  },
  deleteMitigationControl({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const impactIndex = risk.impactos.findIndex(impact => impact.id === params.impactId);
      if (impactIndex >= 0) {
        const impact = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex]
          .impactos[impactIndex];
        const controlIndex = impact.controles_mitigadores.findIndex(control => control.id
          === params.controlId);
        if (controlIndex >= 0) {
          commit(RESET_STATUS_RISK, riskIndex);
          commit(DELETE_MITIGATION_CONTROL, {
            riskIndex,
            impactIndex,
            controlIndex,
          });
        }
      }
    }
  },
  editMitigationControl({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      commit(RESET_STATUS_RISK, riskIndex);
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      risk.impactos.forEach((impact, impactIndex) => {
        // Se busca si este impacto ya tiene este control asignado
        let controlIndex = -1;
        if (impact.controles_mitigadores) {
          controlIndex = impact.controles_mitigadores.findIndex(control => control.id
            === params.controlId);
        }

        // El control editado, tiene asociada este impacto?
        if (params.control.impacto === impact.id) {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            commit(EDIT_MITIGATION_CONTROL, {
              riskIndex,
              impactIndex,
              controlIndex,
              controlMitigador: params.control.nombre,
              critico: params.control.critico,
            });
          } else {
            // Agregar control a impacto
            commit(ADD_MITIGATION_CONTROL, {
              riskIndex,
              impactIndex,
              controlMitigador: params.control.nombre,
              controlMitigadorId: params.controlId,
              critico: params.control.critico,
            });
          }
          // El control editado no tiene este impacto asociada actualmente
        } else {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            // Entonces se borra
            commit(DELETE_MITIGATION_CONTROL, {
              riskIndex,
              impactIndex,
              controlIndex,
            });
          }
        }
      });
    }
  },
  deleteRiskReviewed({
    commit,
    state,
  }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: params,
      };
      axios.delete(SERVICE_DELETE_RISK_REVIEWED_URL, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            resolve({
              status: true,
            });
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  updateRiskStatus({
    commit,
    state,
  }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(SERVICE_UPDATE_RISK_STATUS_URL, params, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            resolve({
              status: true,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  updateRiskReviewed({
    commit,
    state,
  }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(SERVICE_UPDATE_RISK_REVIEWED_URL, params, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            try {
              commit(EDIT_RISK, params.risk);
            } catch (e) {
              console.error(e);
            }

            resolve({
              status: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  addEvaluator({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      commit(RESET_STATUS_RISK, riskIndex);
      commit(ADD_EVALUATOR, {
        index: riskIndex,
        evaluator: params.evaluador,
      });
    }
  },
  deleteEvaluator({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const evaluatorIndex = risk.evaluadores.findIndex(evaluator => evaluator.id === params
        .evaluadorId);
      if (evaluatorIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(DELETE_EVALUATOR, {
          riskIndex,
          evaluatorIndex,
        });
      }
    }
  },
  editEvaluator({
    commit,
    state,
  }, params) {
    const risks = state.inventario.tareas[state.selectedIndexTask].riesgos;
    const riskIndex = risks.findIndex(risk => risk._id === params.riskId);
    if (riskIndex >= 0) {
      const risk = state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex];
      const evaluatorIndex = risk.evaluadores.findIndex(evaluator => evaluator.id === params
        .evaluadorId);
      if (evaluatorIndex >= 0) {
        commit(RESET_STATUS_RISK, riskIndex);
        commit(EDIT_EVALUATOR, {
          riskIndex,
          evaluatorIndex,
          evaluator: params.evaluador,
        });
      }
    }
  },
  getLastPDF({
    commit,
  }) {
    if (parseInt(state.inventario.status) === 2 || parseInt(state.inventario.status) === 3) {
      console.log('PDF not yet created. Requesting...');
      return new Promise((resolve) => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        };
        axios.get(`${SERVICE_GET_PDF_URL}/${state.inventario._id}`, config)
          .then((response) => {
            if (response.status === 200) {
              downloadPDF(response, 'inventario.pdf');
              resolve();
            }
          });
      });
    }
  },
  getPDF({
    commit,
  }, id) {
    return new Promise((resolve) => {
      axios.get(`/inventarios/print/${id}`)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'inventario.pdf');
            resolve();
          }
        });
    });
  },
  getPDFById({
    commit,
  }, body) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(`/inventarios/printById/${body.id}`, { version: body.version }, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'inventario.pdf');
            resolve();
          }
        });
    });
  },
  getReviewPDF({
    commit,
  }) {
    if (parseInt(state.inventario.status) === 1) {
      console.log('PDF not yet created. Requesting...');
      return new Promise((resolve) => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        };

        axios.get(`${SERVICE_GET_PDF_REVIEW_URL}/${state.inventario._id}`, config)
          .then((response) => {
            if (response.status === 200) {
              downloadPDF(response, 'inventario.pdf');
              resolve();
            }
          });
      });
    }
  },
  getPDFs({
    commit,
  }) {
    return new Promise((resolve) => {
      resolve(state.inventario.pdfs);
    });
  },
  getPDFMedioambiente({
    commit,
  }) {
    if (parseInt(state.inventario.status) === 2 || parseInt(state.inventario.status) === 3) {
      console.log('PDF not yet created. Requesting...');
      return new Promise((resolve) => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        };
        axios.get(`${SERVICE_GET_PDF_MEDIOAMBIENTAL_URL}/${state.inventario._id}`, config)
          .then((response) => {
            if (response.status === 200) {
              downloadPDF(response, 'PDFMedioambiente.pdf');
              resolve();
            }
          });
      });
    }
  },
  getPDFTask({
    commit,
  }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(SERVICE_GET_PDF_TAREA_URL, params, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'Tarea.pdf');
            resolve();
          }
        });
    });
  },
  getPDFRiesgoBowtieInv({
    commit,
  }, id) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(`${GET_PDF_RIESGO_BOWTIE_INV_URL}/${id}`, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'RiesgoBowtie.pdf');
            resolve();
          } // if
        });
    });
  },
  getPDFRiesgoBowtie({
    commit,
  }, id) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(`${GET_PDF_RIESGO_BOWTIE_URL}/${id}`, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'RiesgoBowtie.pdf');
            resolve();
          } // if
        });
    });
  },
  getPDFRiesgoTablaInv({
    commit,
  }, id) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(`${GET_PDF_RIESGO_TABLA_INV_URL}/${id}`, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'RiesgoTablaInv.pdf');
            resolve();
          }
        });
    });
  },
};

const mutations = {
  [REPLACE_RISKS](state, data) {
    var ids_tareas = data.selected.map(s => (s.tarea_id));
    var ids_riesgos = data.selected.map(s => (s.riesgo_id));
    state.inventario.tareas.forEach((t, i_tarea) => {
      if (ids_tareas.includes(t.id) || ids_tareas.includes(t._id)) {
        t.riesgos.forEach((r, i_riesgo) => {
          var riesgo = JSON.parse(JSON.stringify(data.riesgo))
          riesgo["_id"] = uuid();
          if (ids_riesgos.includes(r.id) || ids_riesgos.includes(r._id)) {
            state["inventario"]["tareas"][i_tarea]["riesgos"].splice(i_riesgo, 1, riesgo);
          }
        });
      }
    });
    console.log(state["inventario"]["tareas"])
  },
  [DOWN_TASK](state, index) {
    if (index === state.inventario.tareas.length - 1) {
      return;
    }

    let subsequentIndex = index + 1;

    let itemCopy = { ...state.inventario.tareas[index] };
    let subsequentItemCopy = { ...state.inventario.tareas[subsequentIndex] };

    // Swap array positions with subsequent element
    state.inventario.tareas[subsequentIndex] = itemCopy;
    state.inventario.tareas[index] = subsequentItemCopy;
  },
  [UP_TASK](state, index) {
    if (index === 0) {
      return;
    }

    let priorIndex = index - 1;

    let itemCopy = { ...state.inventario.tareas[index] };
    let priorItemCopy = { ...state.inventario.tareas[priorIndex] };

    // Swap array position with prior element
    state.inventario.tareas[priorIndex] = itemCopy;
    state.inventario.tareas[index] = priorItemCopy;
  },
  [DOWN_RISK](state, index) {
    if (index === state.inventario.tareas[state.selectedIndexTask]["riesgos"].length - 1) {
      return;
    }

    let subsequentIndex = index + 1;

    let itemCopy = { ...state.inventario.tareas[state.selectedIndexTask]["riesgos"][index] };
    let subsequentItemCopy = { ...state.inventario.tareas[state.selectedIndexTask]["riesgos"][subsequentIndex] };

    // Swap array positions with subsequent element
    state.inventario.tareas[state.selectedIndexTask]["riesgos"][subsequentIndex] = itemCopy;
    state.inventario.tareas[state.selectedIndexTask]["riesgos"][index] = subsequentItemCopy;
  },
  [UP_RISK](state, index) {
    if (index === 0) {
      return;
    }

    let priorIndex = index - 1;

    let itemCopy = { ...state.inventario.tareas[state.selectedIndexTask]["riesgos"][index] };
    let priorItemCopy = { ...state.inventario.tareas[state.selectedIndexTask]["riesgos"][priorIndex] };

    // Swap array position with prior element
    state.inventario.tareas[state.selectedIndexTask]["riesgos"][priorIndex] = itemCopy;
    state.inventario.tareas[state.selectedIndexTask]["riesgos"][index] = priorItemCopy;
  },
  [RESET_CAMBIOS](state, index) {
    state.cambios = [];
  },
  [DELETE_CAMBIO](state, index) {
    state.cambios.splice(index, 1);
  },
  [SET_STATUS_CAMBIO](state, cambio) {
    state.cambios.push(cambio);
  },
  [CHANGE_STATUS_CAMBIO](state, cambios) {
    state.cambios = cambios;
  },
  [EDIT_RISK](state, risk) {
    if (state.inventario.tareas && state.inventario.tareas.length > 0) {
      state.inventario.tareas.forEach((t) => {
        t.riesgos.forEach((r) => {
          if (r._id === risk._id) Object.assign(r, risk);
        });
      });
    }
  },
  [EDIT_INVENTORY](state, obj) {
    Object.assign(state.inventario, obj);
  },
  [ASSIGN_RISK](state, {
    risk,
    obj,
  }) {
    Object.assign(risk, obj);
  },
  [ADD_PDF](state, link) {
    if (!state.inventario.pdfs) {
      Vue.set(state.inventario, 'pdfs', []);
    }
    state.inventario.pdfs.push(link);
  },
  [SET_INVENTORY](state, inventory) {
    state.inventario = inventory;
  },
  [SET_INVENTORY_COPY](state, inventory) {
    putoIEAssign(state, 'inventario_copy', JSON.parse(JSON.stringify(inventory)));
  },
  [ADD_TASK](state, taskName) {
    if (taskName.anual && taskName.anual === true) {
      const task = {
        _id: uuid(),
        nombre: taskName.task,
      };
      if (!state.inventario_copy.tareas) {
        Vue.set(state.inventario_copy, 'tareas', []);
      }
      state.inventario_copy.tareas.push(task);
    } else {
      const task = {
        _id: uuid(),
        nombre: taskName.task,
      };
      if (!state.inventario.tareas) {
        Vue.set(state.inventario, 'tareas', []);
      }
      state.inventario.tareas.push(task);
    }
  },
  [ADD_PARTICIPANTE](state, participante) {
    if (state.inventario.evaluadores) {
      state.inventario.evaluadores.push(participante);
    } else {
      state.inventario["evaluadores"] = [];
      state.inventario.evaluadores.push(participante);
    }
  },
  [EDIT_PARTICIPANTE](state, participante) {
    const pos = state.inventario.evaluadores.map(e => e.id).indexOf(participante.id);
    if (pos !== -1) {
      state.inventario.evaluadores[pos] = participante;
    }
  },
  [DELETE_PARTICIPANTE](state, participante) {
    const pos = state.inventario.evaluadores.map(e => e.id).indexOf(participante.id);
    if (pos !== -1) {
      state.inventario.evaluadores.splice(pos, 1);
    }
  },
  [DELETE_TASK](state, task) {
    if (task.anual && task.anual === true && [2, "2"].includes(state.inventario.status)) {
      const indexTask = state.inventario_copy.tareas.findIndex(tarea => (tarea.id || tarea._id) === (task
        .id || task._id));
      state.inventario_copy.tareas.splice(indexTask, 1);
    } else {
      const indexTask = state.inventario.tareas.findIndex(tarea => (tarea.id || tarea._id) === (task
        .id || task._id));
      state.inventario.tareas.splice(indexTask, 1);
    }
  },
  [EDIT_TASK](state, params) {
    if (params.anual === true) {
      const indexTask = state.inventario_copy.tareas.findIndex(tarea => (tarea.id || tarea._id)
        === params.taskId);
      state.inventario_copy.tareas[indexTask].nombre = params.nombre;
    } else {
      const indexTask = state.inventario.tareas.findIndex(tarea => (tarea.id || tarea._id)
        === params.taskId);
      state.inventario.tareas[indexTask].nombre = params.nombre;
      state.inventario.tareas[indexTask].subtitulo = params.subtitulo;
    }
  },
  [SELECT_TASK](state, indexTask) {
    state.selectedIndexTask = indexTask;
  },
  [ADD_RISK](state, params) {
    if (params.anual === true) {
      if (!state.inventario_copy.tareas[params.indexTask].riesgos) {
        Vue.set(state.inventario_copy.tareas, params.indexTask, {
          ...state.inventario_copy.tareas[params.indexTask],
          riesgos: [],
        });
      }
      state.inventario_copy.tareas[params.indexTask].riesgos.push(params.risk);
    } else {
      if (!state.inventario.tareas[params.indexTask].riesgos) {
        Vue.set(state.inventario.tareas, params.indexTask, {
          ...state.inventario.tareas[params.indexTask],
          riesgos: [],
        });
      }
      state.inventario.tareas[params.indexTask].riesgos.push(params.risk);
    }
  },
  [ADD_RISK_ANUAL](state, params) {
    if (!state.inventario_copy.tareas[params.indexTask].riesgos) {
      Vue.set(state.inventario_copy.tareas, params.indexTask, {
        ...state.inventario_copy.tareas[params.indexTask],
        riesgos: [],
      });
    }
    state.inventario_copy.tareas[params.indexTask].riesgos.push(params.risk);
  },
  [DELETE_RISK](state, params) {
    if (params.anual === true) {
      state.inventario_copy.tareas[params.indexTask].riesgos.splice(params.indexRisk, 1);
    } else {
      state.inventario.tareas[params.indexTask].riesgos.splice(params.indexRisk, 1);
    }
  },
  [ADD_CUSTOM_RISK](state, params) {
    if (!state.inventario.tareas[params.indexTask].riesgos) {
      Vue.set(state.inventario.tareas, params.indexTask, {
        ...state.inventario.tareas[params.indexTask],
        riesgos: [],
      });
    }
    const risk = {
      _id: uuid(),
      nombre: params.nombre,
      custom: true,
      escenario: null,
      medioambiental: params.medioambiental,
      medioambiente: {
        responsable: null,
        condicion: null,
        evento: null,
        equipo: null,
        aspecto: null,
      },
      evaluadores: [],
      causas: [],
      impactos: [],
      status: 0,
      status_step: 0,
    };
    state.inventario.tareas[params.indexTask].riesgos.push(risk);
  },
  [EDIT_CUSTOM_RISK](state, params) {
    state.inventario.tareas[params.indexTask].riesgos[params.indexRisk] = params.risk;
  },
  [EDIT_CUSTOM_RISK_YEAR](state, params) {
    state.inventario_copy.tareas[params.indexTask].riesgos[params.indexRisk] = params.risk;
  },
  [ADD_CAUSE](state, params) {
    if (!state.inventario.tareas[state.selectedIndexTask].riesgos[params.index].causas) {
      Vue.set(
        state.inventario.tareas[state.selectedIndexTask].riesgos,
        params.index, {
        ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.index],
        causas: [],
      },
      );
    }
    const cause = {
      id: uuid(),
      nombre: params.causa,
    };
    state.inventario.tareas[state.selectedIndexTask].riesgos[params.index].causas.push(cause);
  },
  [ADD_IMPACT](state, params) {
    if (!state.inventario.tareas[state.selectedIndexTask].riesgos[params.index].impactos) {
      Vue.set(
        state.inventario.tareas[state.selectedIndexTask].riesgos,
        params.index, {
        ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.index],
        impactos: [],
      },
      );
    }
    const impact = {
      id: uuid(),
      descripcion: params.impacto.descripcion,
      categoria: params.impacto.categoria,
      factor_severidad: params.impacto.factor_severidad,
      nivel_severidad: params.impacto.nivel_severidad,
      factor_probabilidad: params.impacto.factor_probabilidad,
      mfl: params.impacto.mfl,
    };
    state.inventario.tareas[state.selectedIndexTask].riesgos[params.index].impactos.push(impact);
  },
  [ADD_PREVENTIVE_CONTROL](state, params) {
    if (!state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[params
      .causeIndex].controles_preventivos) {
      Vue.set(
        state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas,
        params.causeIndex, {
        ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[
        params.causeIndex],
        controles_preventivos: [],
      },
      );
    }
    const controlPreventivo = {
      id: params.controlPreventivoId,
      nombre: params.controlPreventivo,
      critico: params.critico,
    };
    state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[params
      .causeIndex].controles_preventivos.push(
        controlPreventivo,
      );
  },
  [ADD_MITIGATION_CONTROL](state, params) {
    if (!state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos[
      params.impactIndex].controles_mitigadores) {
      Vue.set(
        state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos,
        params.impactIndex, {
        ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex]
          .impactos[params.impactIndex],
        controles_mitigadores: [],
      },
      );
    }
    const controlMitigador = {
      id: params.controlMitigadorId,
      nombre: params.controlMitigador,
      critico: params.critico,
    };
    state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos[params
      .impactIndex].controles_mitigadores.push(
        controlMitigador,
      );
  },
  [DELETE_CAUSE](state, params) {
    Vue.delete(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas,
      params.causeIndex,
    );
  },
  [EDIT_CAUSE](state, params) {
    Vue.set(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas,
      params.causeIndex, {
      ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[
      params.causeIndex],
      nombre: params.cause,
    },
    );
  },
  [DELETE_IMPACT](state, params) {
    Vue.delete(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos,
      params.impactIndex,
    );
  },
  [EDIT_IMPACT](state, params) {
    Vue.set(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos,
      params.impactIndex, {
      ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos[
      params.impactIndex],
      categoria: params.impact.categoria,
      descripcion: params.impact.descripcion,
      factor_severidad: params.impact.factor_severidad,
      factor_probabilidad: params.impact.factor_probabilidad,
      nivel_severidad: params.impact.nivel_severidad,
      mfl: params.impact.mfl,
    },
    );
  },
  [DELETE_PREVENTIVE_CONTROL](state, params) {
    Vue.delete(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[params
        .causeIndex].controles_preventivos,
      params.controlIndex,
    );
  },
  [EDIT_PREVENTIVE_CONTROL](state, params) {
    Vue.set(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[params
        .causeIndex].controles_preventivos,
      params.controlIndex, {
      ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].causas[
        params.causeIndex].controles_preventivos[params.controlIndex],
      nombre: params.controlPreventivo,
      critico: params.critico,
    },
    );
  },
  [DELETE_MITIGATION_CONTROL](state, params) {
    Vue.delete(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos[params
        .impactIndex].controles_mitigadores,
      params.controlIndex,
    );
  },
  [EDIT_MITIGATION_CONTROL](state, params) {
    Vue.set(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos[params
        .impactIndex].controles_mitigadores,
      params.controlIndex, {
      ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].impactos[
        params.impactIndex].controles_mitigadores[params.controlIndex],
      nombre: params.controlMitigador,
      critico: params.critico,
    },
    );
  },
  [ADD_EVALUATOR](state, params) {
    if (!state.inventario.tareas[state.selectedIndexTask].riesgos[params.index].evaluadores) {
      Vue.set(
        state.inventario.tareas[state.selectedIndexTask].riesgos,
        params.index, {
        ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.index],
        evaluadores: [],
      },
      );
    }
    const evaluator = {
      id: uuid(),
      nombre: params.evaluator.nombre,
      rut: params.evaluator.rut,
      cargo: params.evaluator.cargo,
      empresa: params.evaluator.empresa,
    };
    state.inventario.tareas[state.selectedIndexTask].riesgos[params.index].evaluadores.push(
      evaluator,
    );
  },
  [DELETE_EVALUATOR](state, params) {
    Vue.delete(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].evaluadores,
      params.evaluatorIndex,
    );
  },
  [EDIT_EVALUATOR](state, params) {
    Vue.set(
      state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex].evaluadores,
      params.evaluatorIndex, {
      ...state.inventario.tareas[state.selectedIndexTask].riesgos[params.riskIndex]
        .evaluadores[params.evaluatorIndex],
      nombre: params.evaluator.nombre,
      rut: params.evaluator.rut,
      cargo: params.evaluator.cargo,
      empresa: params.evaluator.empresa,
    },
    );
  },
  [RESET_STATUS_RISK](state, riskIndex) {
    Vue.set(
      state.inventario.tareas[state.selectedIndexTask].riesgos,
      riskIndex, {
      ...state.inventario.tareas[state.selectedIndexTask].riesgos[riskIndex],
      status: 0,
      status_step: 0,
      status_by: null,
      status_position: null,
      status_message: null,
    },
    );
  },
  [SET_INVENTORY_STATUS](state, status) {
    state.inventario.status = status;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
